export const topics = [
  {
    id: 1,
    name: '恋情观察',
    slug: 'romance',
    description: '从同款单品到行程重合，梳理那些被网友反复放大解读的暧昧信号，只呈现线索不替当事人下结论。',
    icon: 'ri-heart-3-line',
    articleCount: 42,
    heat: 9640,
    color: 'primary' as const,
  },
  {
    id: 2,
    name: '影视风向',
    slug: 'screen',
    description: '剧集与电影的口碑起伏、票房走势、结局争议，把散落的观众评价整理成一条清晰的曲线。',
    icon: 'ri-film-line',
    articleCount: 58,
    heat: 9210,
    color: 'accent' as const,
  },
  {
    id: 3,
    name: '综艺名场面',
    slug: 'variety',
    description: '那些让弹幕刷屏、被剪成二创的瞬间，连同现场背景与后续回应一起补齐。',
    icon: 'ri-mic-line',
    articleCount: 36,
    heat: 8730,
    color: 'secondary' as const,
  },
  {
    id: 4,
    name: '舞台与音乐',
    slug: 'stage',
    description: '演唱会加场、音乐节阵容、票务抢购，关注现场与台前幕后的一切动态。',
    icon: 'ri-music-2-line',
    articleCount: 31,
    heat: 8290,
    color: 'primary' as const,
  },
  {
    id: 5,
    name: '榜单数据',
    slug: 'charts',
    description: '新媒体指数、话题阅读量、商业价值榜，用可视化的方式解读数字背后的走势。',
    icon: 'ri-bar-chart-2-line',
    articleCount: 27,
    heat: 7860,
    color: 'accent' as const,
  },
  {
    id: 6,
    name: '品牌联名',
    slug: 'brand',
    description: '联名发售、代言官宣、周边秒空，关注娱乐与消费之间正在发生的化学反应。',
    icon: 'ri-price-tag-3-line',
    articleCount: 24,
    heat: 7420,
    color: 'secondary' as const,
  },
  {
    id: 7,
    name: '海外甜瓜',
    slug: 'overseas',
    description: '海外颁奖礼、偶像团体、跨国合作的现场动态与后台花絮汇总。',
    icon: 'ri-earth-line',
    articleCount: 19,
    heat: 6980,
    color: 'primary' as const,
  },
  {
    id: 8,
    name: '网红圈',
    slug: 'creator',
    description: '内容创作者的涨粉与翻车、直播争议与团队回应，记录流量场里的高光与反思。',
    icon: 'ri-video-line',
    articleCount: 22,
    heat: 6540,
    color: 'accent' as const,
  },
];